import { iamApi } from './client'

export const ORG_TYPES = [
  'Sole Proprietorship',
  'Partnership',
  'Limited Liability Partnership',
  'Private Limited Company',
  'Public Limited Company',
  'Non-Profit Organization',
] as const

export type OrgType = typeof ORG_TYPES[number]

export const INDUSTRIES = [
  'Information Technology',
  'Healthcare',
  'Financial Services',
  'Manufacturing',
  'Retail',
  'Education',
  'Telecommunications',
  'Real Estate',
  'Transportation & Logistics',
  'Energy & Utilities',
  'Media & Entertainment',
  'Government',
  'Consulting',
  'E-Commerce',
  'Hospitality & Tourism',
  'Agriculture',
  'Construction',
  'Legal Services',
  'Non-Profit',
  'Other',
] as const

export type Industry = typeof INDUSTRIES[number]

export type ModuleKey = 'ticket-mgmt' | 'client-mgmt' | 'invoice-mgmt' | 'hr-mgmt' | 'asset-mgmt' | 'white-labeling'

export interface CreateOrgPayload {
  basicInformation: {
    id: string
    name: string
    typeOfOrganization: OrgType
    industry: Industry
    description?: string
    timeZone?: string
  }
  subscribedServices: ModuleKey[]
  contactInformation: {
    address: string
    city: string
    state: string
    country: string
    postalCode: string
    phoneNumber: string
  }
  administrativeInformation?: {
    registrationNumber?: string
    dateOfIncorporation?: string
    pan?: string
    gst?: string
    websiteUrl?: string
  }
}

export interface OrgCreatedResponse {
  id: string
  orgId: string
  name: string
}

export interface UserAttributes {
  userName: string
  email: string
  firstName: string
  lastName: string
  roles: string[]
  features: string[]
  organizationId?: string
}

export interface IAMUserProfile {
  userName: string
  firstName: string
  lastName: string
  emailAddress: string
  mobile?: string
  jobTitle?: string
  department?: string
  description?: string
  clientName?: string
  orgId?: string
  roleName?: string[]
}

export interface UpdateIAMUserPayload {
  userName: string
  firstName: string
  lastName: string
  emailAddress: string
  mobile?: string
  jobTitle?: string
  department?: string
  description?: string
  clientName?: string
  orgId?: string
  roleName?: string[]
}

export interface ChangePasswordPayload {
  userName: string
  newPassword: string
  confirmPassword: string
}

export const iamService = {
  createOrganization: (payload: CreateOrgPayload) =>
    iamApi.post<OrgCreatedResponse>('/api/v1/iam/organizations', payload),

  uploadAttachment: (file: File, type: 'logo' | 'logoIcon') => {
    const form = new FormData()
    form.append('file', file)
    form.append('type', type)
    return iamApi.upload<{ url: string; fileName: string }>('/api/v1/iam/attachments', form)
  },

  getUserAttributes: () =>
    iamApi.get<UserAttributes>('/api/v1/iam/getUserAttributes'),

  getCurrentUser: () =>
    iamApi.get<IAMUserProfile>('/api/v1/iam/user'),

  updateCurrentUser: (userName: string, payload: UpdateIAMUserPayload) =>
    iamApi.put<IAMUserProfile>(`/api/v1/iam/users/${encodeURIComponent(userName)}`, payload),

  changePassword: (payload: ChangePasswordPayload) =>
    iamApi.put<string>('/api/v1/iam/password', payload),
}
